import React, { useCallback, useContext } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// Components
import Button from "../Atoms/Button";
import { TrackingContext } from "../Utils/TrackingWrapper";

// Constants
import { ACTIONS } from "../../types/Amplitude";

export const LoadMoreButton = ({
  shouldRender,
  onClick,
  children,
  className,
  disableButton = false,
  trackingProps = {},
}) => {
  const {
    pageUrl,
    trackingActionCreator,
    trackingActions: { trackLoadMore },
  } = useContext(TrackingContext);
  const trackingAction = trackingActionCreator(trackLoadMore, {
    buttonText: children,
    label: children,
    pageUrl,
    action: ACTIONS.Click,
    ...trackingProps,
  });

  const onButtonClick = useCallback(() => {
    onClick();
    trackingAction();
  }, [onClick, trackingAction]);

  // Show the button if there are still more accordions to show
  if (shouldRender) {
    const classes = classNames("load_more_button", className);
    return (
      <Button
        buttonType="secondary"
        className={classes}
        onClick={onButtonClick}
        isDisabled={disableButton}
      >
        {children}
      </Button>
    );
  }

  return null;
};

LoadMoreButton.propTypes = {
  shouldRender: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.any,
  disableButton: PropTypes.bool,
};

LoadMoreButton.defaultProps = {
  children: "Load More",
};

export default LoadMoreButton;
